/**
 * @module app.track.config
 */
import appTrackService from '../track/service.js';

class Controller {
  /**
   * @param {app.track.service} appTrackService
   * @ngInject
   */
  constructor(appTrackService) {
    /**
     * @private
     */
    this.appTrackService_ = appTrackService;

    console.assert(this.appTrackService_.selectedTrack);

    /**
     * @export
     * @type {!appx.TrackShowResponse}
     */
    this.track = this.appTrackService_.selectedTrack;

    /**
     * The initial value of the track's properties, used on cancel.
     * @private
     * @type {!Object<string, *>}
     */
    this.trackProperties_ = {
      color: this.track.properties.color,
      color_rgb: this.track.properties.color_rgb,
      opacity: this.track.properties.opacity,
      velospeed: this.track.properties.velospeed,
    };

    /**
     * @type {function()}
     * @export
     */
    this.onLineStyleChanged;

    /**
     * @type {function()}
     * @export
     */
    this.onBikeSpeedChanged;

    /**
     * @type {function()}
     * @export
     */
    this.onConfigSaved;

    /**
     * @type {function()}
     * @export
     */
    this.onConfigCanceled;

    /**
     * @type {boolean}
     * @export
     */
    this.hideActionButtons;
  }

  /**
   * @export
   */
  notifyStyleChange() {
    const {color_rgb, opacity} = this.appTrackService_.selectedTrack.properties;
    this.onLineStyleChanged({color_rgb, opacity});
  }

  /**
   * @export
   */
  notifyBikeSpeedChange() {
    this.onBikeSpeedChanged();
  }

  /**
   * @export
   */
  saveTrackConfig() {
    this.appTrackService_.saveTrackConfig(this.track)
      .finally(() => {
        this.onConfigSaved();
      });
  }

  /**
   * @export
   */
  cancelTrackConfig() {
    Object.entries(this.trackProperties_).forEach(([key, value]) => {
      this.track.properties[key] = value;
    });
    this.notifyStyleChange();
    this.notifyBikeSpeedChange();
    this.onConfigCanceled();
  }

  /**
   * @export
   * @param {number} bicycleSpeed
   */
  setBicycleSpeed(bicycleSpeed) {
    this.track.properties.velospeed = bicycleSpeed;
    this.notifyBikeSpeedChange();
  }

  /**
   * @export
   * @param {app.constants.TRACK_COLOR} color
   * @param {string} colorRgb
   */
  setColor(color, colorRgb) {
    this.track.properties.color = color;
    this.track.properties.color_rgb = colorRgb;
    this.notifyStyleChange();
  }

  /**
   * @export
   * @param {number} opacity
   */
  setOpacity(opacity) {
    this.track.properties.opacity = opacity;
    this.notifyStyleChange();
  }
}


/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'onLineStyleChanged': '&',
    'onBikeSpeedChanged': '&',
    'onConfigCanceled': '&',
    'onConfigSaved': '&',
    'hideActionButtons': '<',
  },
  controller: Controller,
  templateUrl: 'js/app/track/config/partial.html'
};

export default angular.module('appTracksConfigComponent', [
  appTrackService.name
]).component('appTracksConfig', component);
